export const IsWindowUndefined = () => {
  return typeof window === "undefined" || typeof document === "undefined";
};

export type WindowSize = {
  width: number;
  height: number;
};

export const GetWindowSize = (): WindowSize => {
  if (IsWindowUndefined()) {
    return {
      width: 0,
      height: 0
    };
  }
  return {
    width: document.documentElement.clientWidth || window.innerWidth,
    height: document.documentElement.clientHeight || window.innerHeight
  };
};
